import { useEffect, useMemo, useState } from "react";
import "./MyProfile.css";
import { useNavigate } from "react-router-dom";
import AvaterPop from "./Avater/AvaterPop";
import AvatarSuccessfulPopup from "./AvatarSuccessfulPopup";
import { IconButton, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IP } from '../../internalServer'

export default function MyProfile({
  handleProfileClose,
  classTeachers,
  coOrdinators,
}) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [click, setClick] = useState(false);
  const [getResponse, setGetResponse] = useState(false);
  const [imgError, setImgError] = useState(false);
  const [resMessage, setResMessage] = useState({});
  const [toast, setToast] = useState(null);
  const [avtarVersion, setAvtarVersion] = useState(0);
  let studentData = JSON.parse(localStorage.getItem("breathForStudent"));
  const [studentDetails, setStudentDetails] = useState(studentData)
  const navigate = useNavigate();


  function formatDate(inputDate) {
    const inputDateFormat = new Date(inputDate);
    const day = inputDateFormat.getDate().toString().padStart(2, "0");
    const month = (inputDateFormat.getMonth() + 1).toString().padStart(2, "0");
    const year = inputDateFormat.getFullYear().toString().substr();
    return `${day}-${month}-${year}`;
  }
  function findClassTeacherName(objects) {
    for (let i = 0; i < objects?.length; i++) {
      if (objects[i].is_class_teacher === true) {
        return objects[i].teacher.name;
      }
    }
  }

  const handleLogoutClick = () => {
    localStorage.clear();
    classTeachers = [];
    coOrdinators = [];
    handleProfileClose();
    navigate("/");
  };

  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 5000);
  };

  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  const genderLabel = useMemo(
    () => (studentDetails.gender === "M" ? "Male" : "Female"),
    [studentDetails.gender]
  );

  // const computedPhotoSrc = useMemo(() => {
  //   if (previewUrl) return previewUrl;

  //   if (studentDetails.profile_picture) {
  //     const cleaned = studentDetails.profile_picture.replace(/^\./, "");
  //     return cleaned;
  //   }
  //   console.log("studentDetails", studentDetails);

  //   if (studentDetails.gender === "M") {
  //     return studentDetails.avatar_profile
  //       ? `/images/Boys/${studentDetails.avatar_profile}.webp`
  //       : "/images/Student_boy_pic.png";
  //   }

  //   if (studentDetails.gender === "F") {
  //     return studentDetails.avatar_profile
  //       ? `/images/Girls/${studentDetails.avatar_profile}.webp`
  //       : "/images/Student_girl_pic.png";
  //   }

  //   return "/images/default image.png";
  // }, [
  //   previewUrl,
  //   studentDetails.profile_picture,
  //   studentDetails.gender,
  //   studentDetails.avatar_profile,
  // ]);

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadError(null);
    setImgError(false);

    if (file.type.startsWith("image/")) {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      setToast("Photo updated for preview (not saved)");
      const t = setTimeout(() => setToast(null), 2800);
      return () => clearTimeout(t);
    } else {
      setPreviewUrl(null);
      setUploadError(
        "Selected file is not an image. Only images can be used as a profile picture."
      );
    }
  };

  const onImageError = () => {
    setImgError(true);
  };

  const DetailCard = ({ label, value, className = "" }) => (
    <div
      className={`rounded-xl border border-orange-100 bg-orange-50 p-4 shadow-sm 
      hover:shadow-md hover:border-orange-300 hover:bg-orange-100 
      transition-all duration-300 ease-in-out cursor-pointer ${className}`}
    >
      <div className="text-xs font-semibold tracking-wide text-orange-600 uppercase mb-1">
        {label}
      </div>
      <div className="text-sm text-gray-900">{value}</div>
    </div>
  );

  return (
    <div
      className="pb-4 px-2 w-full myprofileContaienr orange-scrollBar"
      style={{ minHeight: "100vh", overflowY: "scroll" }}
    >
      {/* ✅ Page Content */}
      <main className="h-full w-full px-4 sm:px-6 lg:px-8 py-6">
        <div className="relative h-full overflow-hidden rounded-2xl bg-white/80 backdrop-blur-md shadow-lg ring-1 ring-gray-100">
          {/* Decorative gradient header */}
          <div className="relative h-28 bg-gradient-to-r from-orange-500 via-orange-300 to-orange-800">
            {/* Back + Logout inside header */}
            <div className="p-2 flex items-center justify-between relative z-10">
              <div className="flex items-center gap-2">
                <IconButton
                  color="inherit"
                  onClick={handleProfileClose}
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.2)",
                    color: "white",
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.35)" },
                  }}
                >
                  <ArrowBackIcon />
                </IconButton>
              </div>

              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={handleLogoutClick}
                sx={{
                  borderRadius: "20px",
                  textTransform: "capitalize",
                  fontWeight: 600,
                  px: 2.5,
                  py: 0.5,
                  boxShadow: 2,
                  cursor: "pointer",
                }}
              >
                Logout
              </Button>
            </div>

            {/* Decorative lights */}
            <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-white/10 blur-2xl pointer-events-none" />
            <div className="absolute left-10 -bottom-10 w-24 h-24 rounded-full bg-white/10 blur-xl pointer-events-none" />
          </div>

          {/* Identity Row */}
          <div className="px-6 sm:px-8 -mt-12">
            <div className="flex flex-col sm:flex-row sm:items-end gap-4">
              {/* Avatar */}
              <div className="relative group">
                <div onClick={() => setClick(true)} className="cursor-pointer">
                  <div className="relative">
                    {/* {!imgError ? (
                      <img
                        key={avtarVersion}
                        src={computedPhotoSrc}
                        alt="Profile"
                        className="w-24 h-24 sm:w-28 sm:h-28 rounded-full object-cover ring-4 ring-white shadow-md"
                        onError={onImageError}
                      />
                    ) : (
                      <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full ring-4 ring-white shadow-md bg-indigo-50 flex items-center justify-center">
                        <div className="bg-gray-200 border-2 border-dashed rounded-xl w-16 h-16" />
                      </div>
                    )} */}
                    {
                      <img
                        src={
                          studentDetails?.profile_picture
                            ? IP + studentDetails?.profile_picture.replace(/^\./, "")
                            : studentDetails?.gender === "M"
                              ? studentDetails?.avatar_profile
                                ? "/images/Boys/" + studentDetails?.avatar_profile + ".webp"
                                : "/images/Student_boy_pic.png"
                              : studentDetails?.gender === "F"
                                ? studentDetails?.avatar_profile
                                  ? "/images/Girls/" + studentDetails?.avatar_profile + ".webp"
                                  : "/images/Student_girl_pic.png"
                                : "/images/default image.png"
                        }
                        alt="icon"
                        className="w-20 h-20 rounded-full"
                        key={studentDetails?.avatar_profile}
                        onError={(e) => {
                          if (studentDetails?.gender === "M") {
                            e.target.src = studentDetails?.avatar_profile
                              ? "/images/Boys/" + studentDetail?.avatar_profile + ".webp"
                              : "/images/Student_boy_pic.png";
                          } else if (studentDetails?.gender === "F") {
                            e.target.src = studentDetails?.avatar_profile
                              ? "/images/Girls/" + studentDetails?.avatar_profile + ".webp"
                              : "/images/Student_girl_pic.png";
                          } else {
                            e.target.src = "/images/default image.png";
                          }
                        }}
                      />
                    }
                    <span className="absolute -bottom-2 right-1 rounded-md bg-gray-900 text-white text-xs px-2 py-1 shadow opacity-90 group-hover:opacity-100 transition">
                      Change
                    </span>
                  </div>
                </div>

                {/* hidden file input */}
                <input
                  type="file"
                  id="attachFile"
                  accept=".jpg,.jpeg,.png,.webp"
                  className="hidden"
                  onChange={onFileChange}
                />
              </div>

              {/* Name & meta */}
              <div className="pb-2 mt-4 pt-4">
                <h1 className="text-2xl font-semibold text-gray-900 ">
                  {studentDetails.name}
                </h1>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-sm text-gray-600">
                  <span className="inline-flex items-center rounded-full bg-indigo-50 text-indigo-700 px-2.5 py-0.5">
                    Roll No: {studentDetails.code}
                  </span>
                  <span className="inline-flex items-center rounded-full bg-emerald-50 text-emerald-700 px-2.5 py-0.5">
                    {genderLabel}
                  </span>
                  <span className="inline-flex items-center rounded-full bg-gray-100 text-gray-700 px-2.5 py-0.5 fw-bold fs-6">
                    {studentDetails.standard?.name} •{" "}
                    {studentDetails.section?.name}
                  </span>
                </div>
              </div>
            </div>

            {uploadError && (
              <div className="mt-3 text-sm text-amber-600">{uploadError}</div>
            )}
          </div>

          {/* Details Grid */}
          <div className="max-w-6xl mx-auto p-6 bg-white">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-3">
              {/* Student Details */}
              {studentDetails.email && (
                <DetailCard
                  label="School Email"
                  value={
                    <span className="break-all">{studentDetails.email}</span>
                  }
                  className="sm:col-span-2"
                />
              )}

              {studentDetails.date_of_birth && (
                <DetailCard
                  label="DOB"
                  value={formatDate(studentDetails.date_of_birth)}
                />
              )}

              {studentDetails.father?.name && (
                <DetailCard
                  label="Father Name"
                  value={studentDetails.father.name}
                />
              )}

              {studentDetails.mother?.name && (
                <DetailCard
                  label="Mother Name"
                  value={studentDetails.mother.name}
                />
              )}

              {studentDetails.mobile_number && (
                <DetailCard
                  label="Contact"
                  value={studentDetails.mobile_number}
                />
              )}

              {studentDetails.emergency_contact_number && (
                <DetailCard
                  label="Alt Contact"
                  value={studentDetails.emergency_contact_number}
                />
              )}

              {(studentDetails.father?.Email ||
                studentDetails.mother?.Email) && (
                  <DetailCard
                    label="Parents Email"
                    value={
                      <span className="break-all">
                        {studentDetails.father?.Email ||
                          studentDetails.mother?.Email}
                      </span>
                    }
                    className="sm:col-span-2"
                  />
                )}

              {/* Co-Ordinators */}
              {coOrdinators?.length > 0 && (
                <DetailCard
                  label="Co-Ordinators"
                  value={
                    <div className="flex flex-wrap gap-1 mt-1">
                      {coOrdinators.map((c) => (
                        <span
                          key={c}
                          className="inline-flex items-center rounded-full bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700"
                        >
                          {c}
                        </span>
                      ))}
                    </div>
                  }
                />
              )}

              {/* Class Teachers */}
              {classTeachers?.length > 0 && (
                <DetailCard
                  label="Class Teachers"
                  value={
                    <div className="flex flex-wrap gap-1 mt-1">
                      {classTeachers.map((t) => (
                        <span
                          key={t}
                          className="inline-flex items-center rounded-full bg-emerald-50 px-2 py-1 text-xs font-medium text-emerald-700"
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  }
                />
              )}
            </div>
          </div>
        </div>
      </main>

      {click && (
        <AvaterPop
          setStudentDetails={setStudentDetails}
          studentDetails={studentDetails}
          setClick={setClick}
          setResMessage={setResMessage}
          setGetResponse={setGetResponse}
          handleProfileClose={handleProfileClose}
          setAvtarVersion={setAvtarVersion}
        />
      )}
      {getResponse && (
        <AvatarSuccessfulPopup
          handleProfileClose={handleProfileClose}
          setGetResponse={setGetResponse}
          resMessage={resMessage}
          setResMessage={setResMessage}
        />
      )}
    </div>
  );
}
